import { CompositeDataSetReportInDataSet } from 'libs/end-to-end/src/types/databases/data-sets/composite-data-set-config';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { Button } from 'apps/sigma2-ui/src/components/ui/Button';
import { Table } from 'apps/sigma2-ui/src/components/ui/Table';
import { Box } from 'apps/sigma2-ui/src/components/ui/Box';
import React, { useMemo } from 'react';
import { UseGenerateReportsInsightsPayload } from 'apps/sigma2-ui/src/data-wizard/components/composite-dataset/recipes/use-generate-reports-insights';

export const DataSetCompositeReportsConfigComponent = ({
  reports,
  setReports,
  insightsPayload,
}: {
  reports: CompositeDataSetReportInDataSet[];
  setReports: (reports: CompositeDataSetReportInDataSet[]) => void;
  insightsPayload: UseGenerateReportsInsightsPayload;
}) => {
  const generateInsightsUi = useMemo(() => {
    return (
      <Spacing size={'md'} direction={'horizontal'}>
        {insightsPayload.result.type !== 'loading' && (
          <Button
            variant={'outline'}
            size={'small'}
            behavior={{
              type: 'onClick',
              onClick: () => {
                insightsPayload.onGenerateReportsInsights();
              },
            }}
            text={'Generate Insights'}
          />
        )}

        {insightsPayload.result.type === 'loading' && (
          <Button
            variant={'outline'}
            size={'small'}
            behavior={{
              type: 'onClick',
              onClick: () => {
                insightsPayload.onCancel();
              },
            }}
            text={'Cancel'}
          />
        )}

        <div>{insightsPayload.result.type}</div>
      </Spacing>
    );
  }, [insightsPayload]);

  const rowCounts: Record<string, number> = useMemo(() => {
    const rowCounts: Record<string, number> = {};
    if (insightsPayload.result.type !== 'success') {
      return rowCounts;
    }

    const data = insightsPayload.result.reportsInsights;

    for (const report of data) {
      rowCounts[report.reportName] = report.insights.rowCount;
    }

    return rowCounts;
  }, [insightsPayload]);

  return (
    <Spacing size={'lg'} direction={'vertical'}>
      <Spacing size={'md'} direction={'horizontal'}>
        <Button
          className={'bg-white rounded-md'}
          variant={'outline'}
          size={'small'}
          behavior={{
            type: 'onClick',
            onClick: () => {
              setReports([
                ...reports,
                {
                  reportName: '',
                  reportPrefixMatcher: '',
                },
              ]);
            },
          }}
          text={'Add Report'}
        />

        {generateInsightsUi}
      </Spacing>

      <Table
        columnDefinitions={[
          {
            id: 'reportName',
            header: () => <div>Report Name</div>,
            cell: ({ item, rowIndex }) => (
              <Box>
                <input
                  className="form-input"
                  value={item.reportName}
                  onChange={(e) => {
                    setReports(
                      reports.map((report, index) =>
                        index === rowIndex
                          ? {
                              ...report,
                              reportName: e.target.value,
                            }
                          : report,
                      ),
                    );
                  }}
                />
              </Box>
            ),
          },
          {
            id: 'reportPrefixMatcher',
            header: () => <div>Report Prefix Matcher</div>,
            cell: ({ item, rowIndex }) => (
              <Box>
                <input
                  className="form-input"
                  value={item.reportPrefixMatcher}
                  onChange={(e) => {
                    setReports(
                      reports.map((report, index) =>
                        index === rowIndex
                          ? {
                              ...report,
                              reportPrefixMatcher: e.target.value,
                            }
                          : report,
                      ),
                    );
                  }}
                />
              </Box>
            ),
          },
          {
            id: 'rowCount',
            header: () => <div>Row Count</div>,
            cell: ({ item }) => {
              const rowCount = rowCounts[item.reportName];
              return (
                <Box>
                  {rowCount !== undefined ? (
                    <div>{rowCount}</div>
                  ) : (
                    <div>{'N/A'}</div>
                  )}
                </Box>
              );
            },
          },
          {
            id: 'delete',
            header: () => <div>Delete</div>,
            cell: ({ rowIndex }) => (
              <Button
                size={'small'}
                behavior={{
                  type: 'onClick',
                  onClick: () => {
                    setReports(
                      reports.filter((_, index) => index !== rowIndex),
                    );
                  },
                }}
                text={'Delete'}
              />
            ),
          },
        ]}
        items={reports}
      ></Table>
    </Spacing>
  );
};
